
















































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Vue } from "vue/types/vue";
import { InputReviewSearch, Review, ReviewSubjectType } from "@scrile/api-provider/dist/api/ReviewProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useKeepCustomScrollPosition from "@/hooks/useKeepCustomScrollPosition";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import BaseSpinner from "@/components/BaseSpinner";
import CustomScroll from "@/components/CustomScroll";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import ModalView from "@/components/ModalView";
import ReviewRemoveConfirm from "./ReviewRemoveConfirm.vue";
import ReviewsItem from "./ReviewsItem.vue";
import ReviewsSendController from "./ReviewsSendController.vue";

export default defineComponent({
  name: "ReviewsFullListController",
  components: {
    BaseSpinner,
    EmptyContent,
    CustomScroll,
    InfiniteScroll,
    ModalView,
    ReviewsItem,
    ReviewsSendController,
    ReviewRemoveConfirm,
  },
  props: {
    isAuthor: { type: Boolean, default: false },
    postId: { type: String, required: true },
    show: { type: Boolean, default: false },
    allowAddReview: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const { authUserStrict } = useAuthUser();

    const loading = ref(true);
    const list = ref<Vue | undefined>();
    const showConfirm = ref(false);
    const removeReviewId = ref("");

    const { items, enableScroll, getFirstPage, getNextPage, addItem, removeItem } = usePager<Review, InputReviewSearch>(
      (page, data) =>
        providers.ReviewProvider.find({
          data: {
            subjects: [{ subjectId: props.postId, subjectType: ReviewSubjectType.POST }],
            page,
            sort: "TIME,DESC",
            ...data,
          },
        })
    );

    const { scrollToTop } = useKeepCustomScrollPosition(
      computed(() => list.value?.$refs.body as Vue),
      { keepScroll: true, behavior: "smooth" }
    );

    const addReview = (r: Review) => {
      emit("add:review", r);
      addItem(r);
      scrollToTop();
    };

    const removeReviewCb = (id: string) => {
      emit("remove:review", id);
      removeItem(r => r.id === id);
      showConfirm.value = false;
    };

    const showRemoveConfirm = (id: string) => {
      showConfirm.value = true;
      removeReviewId.value = id;
    };

    getFirstPage().finally(() => (loading.value = false));

    return {
      loading,
      authUserStrict,
      items,
      enableScroll,
      showConfirm,
      list,
      removeReviewId,
      getNextPage,
      addReview,
      removeReviewCb,
      showRemoveConfirm,
    };
  },
});
